import '../../node_modules/jquery-once/jquery.once.min';
import './primary-menu';
import './stacktable';
import './alert';
import './collapsers';
import './slick';
import './layout-blocks';
import './curriculum-maps';
import './landing-page';
import './video-modal';
import 'bootstrap/js/src/dropdown.js';
import 'bootstrap/js/src/collapse.js';

(function(jQuery, Drupal) {
  'use strict';
  // 9 times out of 10 it's probably better to make a new file
  // instead of writing code in here.

})(jQuery, Drupal);
